export default __webpack_public_path__ + "media/images/react_icons/car-front-view-11e1aacd44f2c4b4450559e9c6249e5f.svg";